export const COMPONENT_ID = 'PromoteCampaignsComponent';
export const APP_BUNDLE = 'bm-component';
